import React from 'react';
import styles from './GlassTabs.module.css';

export interface TabOption<T extends string = string> {
    id: T;
    label: React.ReactNode;
    color?: string; // CSS color variable or value
    pushRight?: boolean;
}

interface GlassTabsProps<T extends string = string> {
    tabs: TabOption<T>[];
    activeTab: T;
    onChange: (id: T) => void;
    className?: string;
}

export function GlassTabs<T extends string = string>({ tabs, activeTab, onChange, className = '' }: GlassTabsProps<T>) {
    return (
        <div className={`${styles.tabsContainer} ${className}`}>
            {tabs.map((tab) => {
                const isActive = activeTab === tab.id;

                return (
                    <button
                        key={tab.id}
                        onClick={() => onChange(tab.id)}
                        className={`${styles.tab} ${isActive ? styles.active : ''} ${tab.pushRight ? styles.pushRight : ''}`}
                        style={{
                            ...(tab.color && isActive ? { borderBottomColor: tab.color, color: tab.color } : {}),
                            ...(tab.color && !isActive ? { color: tab.color } : {})
                        }}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );
}
